import { h, render } from 'preact';

import pendingPromise from 'utils/pendingPromise';

import TrailerModal from 'components/trailerModal/trailerModal';

export async function showTrailerModal(data, trailer) {
	// if (!data) return;

	const container = document.createElement('div');
	render(<TrailerModal data={data} trailer={trailer || data?.trailer?.url} />, container);

	const dialog = container.firstElementChild;
	if (!dialog || dialog.tagName !== 'DIALOG') {
		throw new Error('No dialog element from TrailerModal');
	}

	const promise = pendingPromise();

	dialog.addEventListener('cancel', () => promise.resolve(null));
	dialog.addEventListener('close', () => promise.resolve(dialog.returnValue));

	document.body.append(dialog);
	dialog.showModal();

	let result = await promise;

	// Wait for potential exit transitions before removing from the dom
	allTransitionsEnded(dialog).then(() => dialog.remove());

	return result;
}

function allTransitionsEnded(node) {
	return Promise.allSettled(node.getAnimations().map(animation => animation.finished));
}